import * as React from "react";
import { Stethoscope, ShieldCheck, Activity, BookOpen, Video, FlaskConical, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const servicesData = [{
  title: "01 Daily Bookkeeping",
  description: "Real-time tracking of every transaction with meticulous precision, ensuring your ledger is always audit-ready and transparent.",
  icon: Stethoscope
}, {
  title: "02 Tax Preparation",
  description: "Strategic tax planning and compliance services designed to minimize liabilities and maximize your business's financial health.",
  icon: ShieldCheck
}, {
  title: "03 Payroll Processing",
  description: "Automated, accurate payroll solutions that handle everything from direct deposits to tax filings with absolute reliability.",
  icon: Activity
}, {
  title: "04 Financial Reporting",
  description: "Comprehensive monthly insights and cash-flow optimization reports to support your most critical strategic decisions.",
  icon: BookOpen
}, {
  title: "05 Cloud Integration",
  description: "Seamless migration to modern fintech tools, providing you with secure, 24/7 access to your financial data from anywhere.",
  icon: Video
}, {
  title: "06 Audit Support",
  description: "Proactive guidance and documentation management to ensure your business remains fully compliant with all regulations.",
  icon: FlaskConical
}];
export default function PrecisionSolutions() {
  return <section data-section-id="240553" id="precision-solutions" className="relative py-24 bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-lg bg-primary/10 blur-[120px]" />
        <div className="absolute -bottom-[20%] -right-[10%] w-[50%] h-[50%] rounded-lg bg-secondary/10 blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default text-foreground mb-6 tracking-tighter">
            Precision Solutions
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed font-default">
            Leveraging cloud-based tools and a detail-oriented team to deliver timely insights that support strategic decision-making and growth.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {servicesData.map((service, i) => <Card key={i} data-index={i} className="group relative overflow-hidden bg-card/60 backdrop-blur-md border-border shadow-md hover:shadow-xl transition-all duration-500 rounded-lg">
              <CardHeader className="pb-4">
                <div className="w-14 h-14 rounded-lg bg-muted/50 shadow-sm border border-border/50 flex items-center justify-center mb-6 group-hover:-translate-y-1.5 transition-transform duration-500 ease-out">
                  <service.icon className="w-7 h-7 text-primary" strokeWidth={1.5} />
                </div>
                <CardTitle className="font-default text-2xl text-foreground leading-tight tracking-tight">
                  {service.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground leading-relaxed font-mono text-sm">
                  {service.description}
                </p>
              </CardContent>
            </Card>)}
        </div>

        <div className="mt-16 flex justify-center">
          <Button variant="link" asChild className="text-base font-medium text-primary hover:text-primary/80 group h-auto p-0">
            <Link to="/OurServicesPage" className="inline-flex items-center gap-2">
              View All Services
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1.5 transition-transform duration-300 ease-out" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}